// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'

import FieldsetPage from '../FieldsetPage'

import MyPersonalInfo from './MyPersonalInfo'
import MySolutions from './MySolutions'

import SupervisorAccountOutlinedIcon from '@material-ui/icons/SupervisorAccountOutlined'

import './index.css'


class MyProfile extends Component {
  render () {
    const {user_data} = this.props.session
    const username = user_data['cognito:username']
    const firstName = user_data['given_name']
    const lastName = user_data['family_name']
    const lastSignedIn = new Date().toLocaleString()
    const permissions = user_data['custom:Role'] === 'TenantAdmin' ? 'Admin' : 'User'

    const initial_values = {
      username: username,
      firstName: firstName,
      lastName: lastName,
      lastSignedIn: lastSignedIn,
      permissions: permissions,
      accountStatus: 'Active'
    }

    if (!user_data) {
      return null
    }

    return (
      <FieldsetPage
        title={<><SupervisorAccountOutlinedIcon/>&nbsp; My Profile</>}
        leftFieldsetLegend='My Personal Info'
        leftFieldsetContent={<MyPersonalInfo initialValues={initial_values}/>}
        rightFieldsetLegend='My Solutions'
        rightFieldsetContent={<MySolutions/>}
      >
      </FieldsetPage>
    )
  }
}

function mapStateToProps ({session}) {
  return {
    session
  }
}

export default connect(mapStateToProps)(MyProfile)
